module.exports = __webpack_public_path__ + "img/teacher-setting.0d2420ee.png";